import React, { useState } from 'react';
import { apiString as api } from '../utils/constants';
import axios from 'axios';

const ProviderContext = React.createContext<any>(null);

export const ProviderProvider = ({ children }: { children: React.ReactNode }) => {
    const [providers, setProviders] = useState<any[]>([]);

    const getProviders = async () => {
        const response = await axios.get(`${api}/provider/getproviderpreview`);
        setProviders(response.data);
    };

    const value = { providers, getProviders, setProviders };

    return <ProviderContext.Provider value={value}>{children}</ProviderContext.Provider>;
};

export const useProviderContext = () => React.useContext(ProviderContext);
